<ion-content class="bg-color ion-content add-user-group">
  <div class="com-content">
    <div class="content-breadcrumb">
      <ul class="breadcrumb">
        <li *ngFor="let itemList of breadcrumbList" class="breadcrumb-item">
          <a routerLink="{{ itemList.url }}">
            {{ itemList.label }}
          </a>
        </li>
      </ul>
    </div>
    <div class="content-grid">
      <div class="m-content">
        <form [formGroup]="addUserGroupForm" (ngSubmit)="onSubmit()">
          <mat-card>
            <mat-card-title class="mc-title">
              <span class="org-header">User Group</span>
            </mat-card-title>
            <mat-card-content class="mc-content">
              <div class="form-container">
                <div class="form-layout">
                  <mat-form-field appearance="outline">
                    <mat-label>Group Name</mat-label>
                    <input type="text" formControlName="groupName" matInput placeholder="group_name" required>
                    <mat-error *ngIf="addUserGroupForm.get('groupName').hasError('required')">
                      Group Name is required.
                    </mat-error>
                    <mat-error *ngIf="addUserGroupForm.get('groupName').hasError('invalidCharacters')">
                      Only letters, numbers, and underscores (_) are allowed.
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Group Description</mat-label>
                    <textarea type="text" formControlName="group_description" matInput placeholder="group_description"></textarea>
                  </mat-form-field>
                </div>
                <div class="btn-signup-grid">
                  <button mat-raised-button class="btn" routerLink="/baseapp/user-group">Cancel</button>
                  <button mat-raised-button type="submit" class="btn btn-signup">Add</button>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </form>
      </div>

      <app-about-page *ngIf="hide1200"></app-about-page>
    </div>
    <app-footer></app-footer>
  </div>
</ion-content>